export default __webpack_public_path__ + "static/media/logo-black.0fb3d73a.png";